module.exports = __webpack_public_path__ + "static/media/filsonsoft.db2cf2e3.otf";